export default "__VITE_ASSET__DumHJn3z__"